export const timeZone = 'Europe/Paris';

export default {
    timeZone,
}
